import { Box, useMediaQuery } from '@material-ui/core';
import React from 'react';
import { BooleanInput, NumberInput } from 'react-admin';

const  OrderFooter =(props,...rest) => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
  return (
  
    <Box display="flex" fullWidth justifyContent="space-btween" flexWrap="wrap">
        <NumberInput {...rest} style={isSmall ? {width:'100%'}:{width:'20%',marginRight:20}} fullWidth source="frais_enlevement"  label="Frais enlèvement"   />
        <BooleanInput  source="gratuit_excep"  label="Gratuit exceptionnel" style={isSmall ? null:{width:'20%',marginTop:15}}  />
    </Box>     
          
    );
};

export default OrderFooter;
